import React, { useCallback } from 'react';
import {
  ButtonSectionWrapper,
  VerticalSeparatorDiv,
} from '../DataModelerCommonUI';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { dataModelerSelectCurrentUiState } from '../../../../redux/selectors/dataModeler';
import { dataModelerSetUiDraftDerivedField } from '../../../../redux/slices/dataModeler';
import { useViewColumnsValidator } from '../validation';
import { defaultNewDerivedFieldDefinitionDraft } from './utils';
import { pluralize } from '../../../../utils/formatText';
import DerivedDefinitionIcon from '../../../../components/DerivedDefinitionIcon';
import { TextButton } from '../../../../components/Button';

interface IProps {
  isEditMode: boolean;
  numFields: number;
}
const FieldsSubHeader = ({ isEditMode, numFields }: IProps) => {
  const uiState = useAppSelector(dataModelerSelectCurrentUiState);
  const dispatch = useAppDispatch();

  const { allOtherColumnsSet } = useViewColumnsValidator();
  const handleAddDerivedFieldDraft = useCallback(() => {
    dispatch(
      dataModelerSetUiDraftDerivedField({
        draft: defaultNewDerivedFieldDefinitionDraft(allOtherColumnsSet),
      }),
    );
  }, [allOtherColumnsSet, dispatch]);

  return (
    <ButtonSectionWrapper>
      {numFields} {pluralize('Field', numFields)}
      {isEditMode && !uiState?.draftDerivedField && (
        <>
          <VerticalSeparatorDiv layout="vertical" size="short" />
          <TextButton onClick={handleAddDerivedFieldDraft}>
            + Add Derived Field
            <DerivedDefinitionIcon />
          </TextButton>
        </>
      )}
    </ButtonSectionWrapper>
  );
};

export default FieldsSubHeader;
